
import Hero from './components/Hero';
import PCRepair from './components/PCRepair';
import ChromebookRepair from './components/ChromebookRepair';
import Software from './components/Software';
import Reviews from './components/Reviews';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <PCRepair />
      <ChromebookRepair />
      <Software />
      <Reviews />
      <Contact />
      <Footer />
    </div>
  );
}
